<template>
  <div class="qvp-kids-list-page">
    <div class="section pt-0 mt-0">
      <div class="listed-detail mt-3">
        <h3 class="text-center mt-2 mal-text custom-title">{{ pageTitle }}</h3>
      </div>
    </div>

    <!-- Filter Section with Accordion -->
    <div class="section inset mt-1 mb-1" v-if="!loading">
      <div class="accordion" id="accordionQvpKidsListFilter">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#qvpKidsListFilterAccordion"
              aria-expanded="false"
            >
              <ion-icon name="filter-outline" role="img" class="md hydrated" aria-label="filter outline"></ion-icon>
              Filter
            </button>
          </h2>
          <div
            id="qvpKidsListFilterAccordion"
            class="accordion-collapse collapse"
            :class="hasActiveFilters ? 'show' : ''"
            data-bs-parent="#accordionQvpKidsListFilter"
          >
            <div class="accordion-body">
              <div id="filterContent" style="padding: 0px !important;">
                <div v-if="showDistrictFilter" class="form-group">
                  <div class="input-wrapper">
                    <label class="label" for="filter_district">District</label>
                    <select
                      class="form-control custom-select"
                      v-model="filters.district"
                      name="filter_district"
                      @change="onDistrictFilterChange"
                    >
                      <option value="">---All---</option>
                      <option v-for="district in districtsList" :key="district.id" :value="district.id">
                        {{ district.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="showZoneFilter" class="form-group">
                  <div class="input-wrapper">
                    <label class="label" for="filter_zone">Zone</label>
                    <select
                      class="form-control custom-select"
                      v-model="filters.zone"
                      name="filter_zone"
                      @change="onZoneFilterChange"
                    >
                      <option value="">---All---</option>
                      <option v-for="zone in zonesList" :key="zone.id" :value="zone.id">
                        {{ zone.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="showUnitFilter" class="form-group">
                  <div class="input-wrapper">
                    <label class="label" for="filter_unit">Unit</label>
                    <select class="form-control custom-select" v-model="filters.unit" name="filter_unit">
                      <option value="">---All---</option>
                      <option v-for="unit in unitsList" :key="unit.id" :value="unit.id">
                        {{ unit.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <div class="input-wrapper">
                    <label class="label mal-text" for="filter_registration_type">Registration</label>
                    <select
                      class="form-control custom-select"
                      v-model="filters.registration_type"
                      name="filter_registration_type"
                    >
                      <option value="">---All---</option>
                      <option value="public">Public Registration</option>
                      <option value="member">Admin Registration</option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;" @click="clearFilters">
                      <ion-icon name="trash-bin-outline" role="img" class="md hydrated" aria-label="clear filters"></ion-icon>
                      Clear
                    </button>
                  </div>
                  <div class="col-6">
                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;" @click="applyFilters">
                      <ion-icon name="search-outline" role="img" class="md hydrated" aria-label="apply filters"></ion-icon>
                      Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Kids Button, Download Excel & Bulk Marks -->
    <div class="section-heading section-heading-add-kids">
      <div class="add-kids-btn-wrap">
        <button type="button" class="btn btn-primary btn-sm" @click="openKidsRegistrationModal" v-if="isAdmin">
          <ion-icon name="add-outline"></ion-icon>
          {{ $t('add_kids') || 'കുട്ടികളെ ചേർക്കുക' }}
        </button>
        <button
          v-if="isAdmin && !isUnitAdmin"
          type="button"
          class="btn btn-success btn-sm"
          @click="downloadExcel"
          :disabled="excelDownloading"
        >
          <span v-if="excelDownloading" class="spinner-border spinner-border-sm"></span>
          <ion-icon v-else name="download-outline"></ion-icon>
          Download Excel
        </button>
        <button
          v-if="isAdmin"
          type="button"
          class="btn btn-secondary btn-sm"
          @click="downloadExamCenterPdf()"
          :disabled="pdfDownloading"
        >
          <span v-if="pdfDownloading" class="spinner-border spinner-border-sm"></span>
          <ion-icon v-else name="document-outline"></ion-icon>
          Mark List PDF
        </button>
        <button
          v-if="isStateAdmin"
          type="button"
          class="btn btn-info btn-sm"
          @click="downloadFinalMarksPdf"
          :disabled="finalMarksPdfDownloading"
        >
          <span v-if="finalMarksPdfDownloading" class="spinner-border spinner-border-sm"></span>
          <ion-icon v-else name="document-text-outline"></ion-icon>
          Final Marks PDF
        </button>
        <button
          v-if="isMarksAdmin"
          type="button"
          class="btn btn-warning btn-sm"
          @click="openBulkMarksModal"
        >
          <ion-icon name="create-outline"></ion-icon>
          Marks
        </button>
        <button
          v-if="showMarkEntryReportButton"
          type="button"
          class="btn btn-info btn-sm"
          @click="openMarkEntryCountReport"
        >
          <ion-icon name="stats-chart-outline"></ion-icon>
          Mark Entry Count Report
        </button>
      </div>
      <!-- Exam center is now selected via a modal opened from "Exam Center PDF" button -->
      <div
        v-if="false && isAdmin && examCenters.length > 1"
        class="exam-center-select"
      >
        <div class="input-wrapper">
          <label class="label mb-1">Exam Center</label>
          <select
            class="form-control form-control-sm exam-center-dropdown"
            v-model="selectedExamCenterId"
          >
            <option value="">-- Select Center --</option>
            <option
              v-for="center in examCenters"
              :key="center.id"
              :value="center.id"
            >
              {{ center.madrasa_name || center.zone_name || ('Center #' + center.id) }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="listview-title mt-0 mal-text custom-title">
      {{ $t('list') || 'ലിസ്റ്റ്' }}
    </div>

    <!-- Search -->
    <div class="search-section">
      <div class="search-box">
        <div class="input-wrapper">
          <input
            type="text"
            class="form-control search-input"
            v-model="search_query"
            @input="handleSearch"
            :placeholder="'Search by name, mobile, or registration number'"
            autocomplete="off"
          />
          <ion-icon name="search-outline" class="search-icon"></ion-icon>
          <button type="button" class="clear-search-btn" v-if="search_query" @click="clearSearch">
            <ion-icon name="close-circle"></ion-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="section text-center" v-if="loading_list">
      <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="section">
      <div class="card">
        <h4 class="text-center mt-1 mal-text error-feedback" v-if="!loading_list && message">{{ message }}</h4>
      </div>
    </div>

    <ul class="listview image-listview inset text" v-if="!loading_list">
      <li
        v-for="(registrant, index) in registrants"
        :key="registrant.id"
        :class="['list-item-container', { 'public-registrant': isPublicRegistration(registrant) }]"
      >
        <div class="item-content">
          <a href="javascript:void(0)" class="item">
            <span class="sl-no">{{ pagination.from + index }}</span>
            <img src="assets/img/sample/avatar/avatar1.png" alt="image" class="image" />
            <div class="in">
              <div class="min-width-50">
                <b>{{ registrant.name || '' }}</b>
                <div v-if="registrationDisplayNo(registrant)" class="text-secondary small mal-text">
                  Reg. No: {{ registrationDisplayNo(registrant) }}
                </div>
                <footer class="text-primary">
                  {{ registrant.mobile ? (registrant.country_code || '') + ' ' + registrant.mobile : '' }}
                  <span v-if="registrant.place" class="mal-text"> | {{ registrant.place }}</span>
                  <span v-if="registrant.age" class="mal-text"> | Age: {{ registrant.age }}</span>
                  <span v-if="registrant.gender" class="mal-text"> | {{ registrant.gender }}</span>
                  <span v-if="registrant.kids_subcategory" class="mal-text text-success">
                    <br />
                    {{ getCategoryDisplayName(registrant.kids_subcategory) }}
                  </span>
                  <span v-if="registrant.payment_status" class="mal-text">
                    <br />
                    <span :class="registrant.payment_status === 'Paid' ? 'text-success' : 'text-danger'">
                      Payment: {{ registrant.payment_status === 'Paid' ? 'Paid' : 'Not Paid' }}
                    </span>
                  </span>
                  <span
                    v-if="registrant.qvp_final_exam_mark !== null && registrant.qvp_final_exam_mark !== undefined && registrant.qvp_final_exam_mark !== ''"
                    class="mal-text"
                  >
                    <br />
                    <span class="final-mark-badge">
                      Final Mark: <b>{{ registrant.qvp_final_exam_mark }}</b>
                      <span
                        v-if="registrant.qvp_final_exam_rank !== null && registrant.qvp_final_exam_rank !== undefined && registrant.qvp_final_exam_rank !== ''"
                      >
                        | Rank: <b>{{ registrant.qvp_final_exam_rank }}</b>
                      </span>
                    </span>
                  </span>
                  <span v-if="registrant.unit" class="mal-text">
                    <br />{{ registrant.unit.name_mal || registrant.unit.name }}
                  </span>
                </footer>
              </div>
            </div>
          </a>

          <div class="card-button dropdown" @click.stop>
            <button
              type="button"
              class="btn btn-link btn-icon"
              data-bs-toggle="modal"
              :data-bs-target="'#actionSheetInset' + registrant.id"
              @click="showActionModel"
            >
              <ion-icon name="ellipsis-horizontal"></ion-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <div class="section mt-2" v-if="!loading_list">
      <vue-awesome-paginate
        v-if="pagination.total > 0"
        :total-items="pagination.total"
        :items-per-page="pagination.per_page"
        :max-pages-shown="3"
        v-model="pagination.current_page"
        :on-click="handlePageChange"
        :show-ending-buttons="true"
        :show-breakpoint-buttons="false"
      />
    </div>

    <!-- Action Sheet Modals -->
    <div v-for="registrant in registrants" :key="'modal-' + registrant.id">
      <div class="modal fade action-sheet" :id="'actionSheetInset' + registrant.id" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('action') || 'Action' }}</h5>
            </div>
            <div class="modal-body">
              <ul class="action-button-list">
                <li v-if="registrant.mobile">
                  <a :href="'tel:' + registrant.mobile" class="btn btn-list">
                    <span>
                      <ion-icon name="call-outline"></ion-icon> {{ $t('call') || 'Call' }}
                    </span>
                  </a>
                </li>
                <li v-if="registrant.whatsapp">
                  <a :href="'https://wa.me/' + registrant.whatsapp_country_code + registrant.whatsapp + '?text='" class="btn btn-list">
                    <span>
                      <ion-icon name="logo-whatsapp"></ion-icon> {{ $t('whatsapp') || 'WhatsApp' }}
                    </span>
                  </a>
                </li>

                <li v-if="isAdmin || canUpdatePayment" class="action-divider"></li>
<li v-if="isAdmin || canUpdatePayment">
                  <a href="javascript:void(0)" @click="openPaymentStatusModal(registrant)" class="btn btn-list" data-bs-dismiss="modal">
                    <span>
                      <ion-icon name="card-outline"></ion-icon> {{ $t('payment_status') || 'Payment Status' }}
                    </span>
                  </a>
                </li>

                <li v-if="isAdmin" class="action-divider"></li>
                <li v-if="isAdmin">
                  <a href="javascript:void(0)" @click="openMarksModal(registrant)" class="btn btn-list" data-bs-dismiss="modal">
                    <span>
                      <ion-icon name="create-outline"></ion-icon> Add Mark / Certificate
                    </span>
                  </a>
                </li>
                <li v-if="isStateAdmin">
                  <a href="javascript:void(0)" @click="openFinalMarksModal(registrant)" class="btn btn-list" data-bs-dismiss="modal">
                    <span>
                      <ion-icon name="create-outline"></ion-icon> Add Final Exam Mark
                    </span>
                  </a>
                </li>
                <li v-if="isAdmin">
                  <a href="javascript:void(0)" @click="openEditKidsModal(registrant)" class="btn btn-list" data-bs-dismiss="modal">
                    <span>
                      <ion-icon name="create-outline"></ion-icon> {{ $t('edit') || 'Edit' }}
                    </span>
                  </a>
                </li>
                <li v-if="isAdmin">
                  <a href="javascript:void(0)" @click="confirmDeleteRegistrant(registrant)" class="btn btn-list text-danger" data-bs-dismiss="modal">
                    <span>
                      <ion-icon name="trash-outline"></ion-icon> {{ $t('delete') || 'Delete' }}
                    </span>
                  </a>
                </li>

                <li class="action-divider"></li>
                <li>
                  <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                    <span>
                      <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') || 'Cancel' }}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mark List PDF modal removed; Mark List PDF now downloads directly based on current zone/unit -->

    <!-- Kids Mark / Certificate modal (single kid) -->
    <div class="modal fade action-sheet" id="kidsMarkModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Marks & Certificate</h5>
          </div>
          <div class="modal-body">
            <div class="action-sheet-content">
              <div class="form-group basic">
                <div class="input-wrapper">
                  <label class="label">Mark</label>
                  <input type="number" class="form-control" v-model.number="marksForm.mark" min="0" max="100" placeholder="Enter mark" />
                </div>
                <div class="text-muted small mt-1">
                  Distinction: 40-50, First Class: 31-39, Second Class: 21-30
                </div>
              </div>
              <div class="form-group basic" v-if="marksForm.grade">
                <div class="input-wrapper">
                  <label class="label">Grade</label>
                  <div class="form-control-plaintext fw-bold">{{ marksForm.grade }}</div>
                </div>
              </div>
              <div class="form-group basic">
                <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="marksForm.loading" @click="saveKidsMark">
                  <span v-show="marksForm.loading" class="spinner-border spinner-border-sm"></span>
                  <span>Save</span>
                </button>
              </div>
              <div class="form-group basic" v-if="marksForm.certificate_url">
                <a :href="marksForm.certificate_url" target="_blank" class="btn btn-success btn-block btn-lg">
                  Download Certificate
                </a>
              </div>
              <div class="form-group basic">
                <button type="button" class="btn btn-secondary btn-block btn-lg" @click="closeMarksModal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Kids Final Exam Mark modal (State admin only) -->
    <div class="modal fade action-sheet" id="kidsFinalMarkModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Final Exam Mark</h5>
          </div>
          <div class="modal-body">
            <div class="action-sheet-content">
              <div class="form-group basic">
                <div class="input-wrapper">
                  <label class="label">Final Mark</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="finalMarksForm.mark"
                    min="0"
                    max="100"
                    placeholder="Enter final exam mark"
                  />
                </div>
              </div>
              <div class="form-group basic">
                <div class="input-wrapper">
                  <label class="label">Rank</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="finalMarksForm.rank"
                    min="1"
                    placeholder="Enter rank"
                  />
                </div>
              </div>
              <div class="form-group basic">
                <button
                  type="button"
                  class="btn btn-primary btn-block btn-lg"
                  :disabled="finalMarksForm.loading"
                  @click="saveKidsFinalMark"
                >
                  <span v-show="finalMarksForm.loading" class="spinner-border spinner-border-sm"></span>
                  <span>Save</span>
                </button>
              </div>
              <div class="form-group basic">
                <button type="button" class="btn btn-secondary btn-block btn-lg" @click="closeFinalMarksModal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bulk Kids Marks / Certificates modal -->
    <div class="modal fade action-sheet" id="bulkKidsMarksModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Marks & Certificates (Bulk)</h5>
          </div>
          <div class="modal-body">
            <div class="action-sheet-content">
              <div v-if="bulkMarksLoading" class="text-center text-muted mb-2">
                Loading kids list...
              </div>
              <div v-else-if="!bulkMarks.length" class="text-center text-muted mb-2">
                No kids in current list to add marks.
              </div>
              <div v-else class="bulk-marks-list">
                <div
                  v-for="entry in bulkMarks"
                  :key="entry.id"
                  class="form-group basic mb-2"
                >
                  <div class="input-wrapper">
                    <label class="label d-block">
                      <span class="fw-bold">
                        {{ entry.name }}
                        <span v-if="entry.place"> ({{ entry.place }})</span>
                      </span>
                    </label>
                    <div class="d-flex align-items-center">
                      <input
                        type="number"
                        class="form-control me-2"
                        v-model.number="entry.mark"
                        min="0"
                        max="100"
                        placeholder="Mark"
                        @input="entry.grade = computeGradeForMark(entry.mark); entry.error = ''"
                      />
                      <span
                        class="grade-badge"
                        :class="{
                          'grade-badge-distinction': entry.grade === 'Distinction',
                          'grade-badge-first': entry.grade === 'First Class',
                          'grade-badge-second': entry.grade === 'Second Class',
                          'grade-badge-participation': entry.grade === 'Participation'
                        }"
                        v-if="entry.grade"
                      >
                        {{ entry.grade }}
                      </span>
                    </div>
                    <div v-if="entry.error" class="text-danger small mt-1">
                      {{ entry.error }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group basic mt-2">
                <button
                  type="button"
                  class="btn btn-primary btn-block btn-lg"
                  :disabled="bulkMarksSaving"
                  @click="saveBulkMarks"
                >
                  <span v-show="bulkMarksSaving" class="spinner-border spinner-border-sm"></span>
                  <span>Save All Marks</span>
                </button>
              </div>

              <div class="form-group basic" v-if="bulkCertificates.length">
                <button
                  type="button"
                  class="btn btn-success btn-block btn-lg"
                  @click="downloadBulkCertificates"
                >
                  Download Certificates ({{ bulkCertificates.length }})
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment status modal -->
    <div class="modal fade action-sheet" id="paymentStatusModel" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('payment_status') || 'Payment Status' }}</h5>
          </div>
          <div class="modal-body">
            <div class="action-sheet-content">
              <div class="form-group basic">
                <div class="input-wrapper">
                  <label class="label">Payment Status</label>
                  <select class="form-control custom-select" v-model="selectedPaymentStatus">
                    <option value="">---Select---</option>
                    <option value="Paid">Paid</option>
                    <option value="Pending">Not Paid</option>
                  </select>
                </div>
                <div class="error-feedback" v-if="paymentStatusMessage">{{ paymentStatusMessage }}</div>
              </div>
              <div class="form-group basic">
                <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="loading" @click="savePaymentStatus">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                  <span>Save</span>
                </button>
                <button type="button" class="btn btn-secondary btn-block btn-lg" @click="closePaymentStatusModal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Kids Registration Modal (custom bottom sheet) -->
    <div class="kids-registration-modal" :class="{ 'modal-open': showKidsModal }" @click.self="closeKidsModal">
      <div class="modal-content-bottom">
        <div class="modal-header-bottom">
          <h4 class="modal-title-bottom">{{ editingRegistrantId ? ($t('edit_kids') || 'Edit Kids') : 'Add Kids' }}</h4>
          <button type="button" class="close-btn" @click="closeKidsModal">
            <ion-icon name="close-outline"></ion-icon>
          </button>
        </div>

        <div class="modal-body-bottom">
          <div class="form-group">
            <label class="label">Name</label>
            <input type="text" class="form-control" v-model="kidsForm.name" placeholder="Name" />
          </div>

          <div class="form-group">
            <label class="label">Age</label>
            <input type="number" class="form-control" v-model="kidsForm.age" @input="handleKidsAgeChange" placeholder="Age" />
          </div>

          <div class="form-group">
            <label class="label">Gender</label>
            <select class="form-control custom-select" v-model="kidsForm.gender">
              <option value="">---Select---</option>
              <option value="Boy">Boy</option>
              <option value="Girl">Girl</option>
            </select>
          </div>

          <div class="form-group">
            <label class="label">Kids Subcategory</label>
            <select class="form-control custom-select" v-model="kidsForm.kids_subcategory">
              <option value="">---Select---</option>
              <option value="junior">Junior</option>
              <option value="senior">Senior</option>
            </select>
          </div>

          <div class="form-group">
            <label class="label">Parent Name</label>
            <input type="text" class="form-control" v-model="kidsForm.parent_name" placeholder="Parent Name" />
          </div>

          <div class="form-group">
            <label class="label">Parent Mobile</label>
            <input type="number" class="form-control" v-model="kidsForm.parent_mobile" placeholder="Mobile" />
          </div>

          <div v-if="isStateAdmin" class="form-group">
            <label class="label">District</label>
            <select class="form-control custom-select" v-model="kidsForm.district_id" @change="handleDistrictChange">
              <option value="">---Select---</option>
              <option v-for="d in allDistricts" :key="d.id" :value="d.id">{{ d.name }}</option>
            </select>
          </div>

          <div v-if="shouldShowZoneField" class="form-group">
            <label class="label">Zone</label>
            <select class="form-control custom-select" v-model="kidsForm.zone_id" @change="handleZoneChange">
              <option value="">---Select---</option>
              <option v-for="z in zones" :key="z.id" :value="z.id">{{ z.name }}</option>
            </select>
          </div>

          <div v-if="shouldShowKidsUnitField" class="form-group">
            <label class="label">Unit</label>
            <select class="form-control custom-select" v-model="kidsForm.unit_id">
              <option value="">---Select---</option>
              <option v-for="u in kidsUnits" :key="u.id" :value="u.id">{{ u.name }}</option>
            </select>
          </div>

          <div v-if="isZoneAdmin" class="form-group">
            <label class="label">Place</label>
            <input type="text" class="form-control" v-model="kidsForm.place" placeholder="Place" />
          </div>

          <div class="form-group basic">
            <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="loadingKidsRegistration" @click="submitKidsRegistration">
              <span v-show="loadingKidsRegistration" class="spinner-border spinner-border-sm"></span>
              <span>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Mark Entry Count Report Modal: centered, smooth open (no bottom popup) -->
    <div class="modal fade report-modal-centered" id="markEntryReportModal" tabindex="-1" role="dialog" aria-labelledby="markEntryReportModalTitle">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header justify-content-between align-items-center">
              <h5 class="modal-title mal-text mb-0" id="markEntryReportModalTitle">Mark Entry Count Report</h5>
              <div class="d-flex align-items-center gap-2">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary me-2"
                  :disabled="pdfDownloading || !markEntryReport.length"
                  @click="downloadQualifiedKidsPdf"
                >
                  <span v-if="pdfDownloading" class="spinner-border spinner-border-sm"></span>
                  <span v-else>Download Qualified List PDF</span>
                </button>
                <button
                  v-if="isZoneAdmin"
                  type="button"
                  class="btn btn-sm btn-outline-success me-2"
                  :disabled="pdfDownloading || !markEntryReport.length"
                  @click="downloadQualifiedKidsHallTicketPdf"
                >
                  <span v-if="pdfDownloading" class="spinner-border spinner-border-sm"></span>
                  <span v-else>Download Hall Ticket PDF</span>
                </button>
                <button type="button" class="close" aria-label="Close" @click="closeMarkEntryReportModal">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          <div class="modal-body">
            <ul class="nav nav-tabs report-modal-tabs">
              <li class="nav-item">
                <a class="nav-link" :class="{ active: markEntryReportTab === 'All' }" href="#" @click.prevent="setMarkEntryReportTab('All')">All</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: markEntryReportTab === 'Junior' }" href="#" @click.prevent="setMarkEntryReportTab('Junior')">Junior</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: markEntryReportTab === 'Senior' }" href="#" @click.prevent="setMarkEntryReportTab('Senior')">Senior</a>
              </li>
            </ul>
            <div v-if="markEntryReportLoading" class="text-center py-4">
              <div class="spinner-border text-primary"></div>
              <p class="mt-2">Loading report...</p>
            </div>
            <div v-else>
              <p class="text-muted small mal-text mb-2">
                <span v-if="markEntryReportGroupBy === 'district'">District-wise final exam eligibility count (State view).</span>
                <span v-else-if="markEntryReportGroupBy === 'zone'">Zone-wise final exam eligibility count (District view).</span>
                <span v-else>Unit-wise final exam eligibility count (Zone view).</span>
                <span v-if="markEntryReportTab !== 'All'"> — {{ markEntryReportTab }} only.</span>
              </p>
              <div class="table-responsive">
                <table class="table table-bordered table-sm">
                  <thead class="table-light">
                    <tr>
                      <th class="mal-text">
                        {{ markEntryReportGroupBy === 'district'
                          ? 'District'
                          : markEntryReportGroupBy === 'zone'
                          ? 'Zone'
                          : 'Unit' }}
                      </th>
                      <th class="mal-text">
                        Qualified for Final Exam
                        <br />
                        <small class="text-muted">Junior: 34–50, Senior: 40–50</small>
                      </th>
                      <th class="mal-text">
                        Participated
                        <br />
                        <small class="text-muted">Below threshold</small>
                      </th>
                      <th class="mal-text">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in markEntryReport" :key="row.name">
                      <td class="fw-bold">{{ row.name }}</td>
                      <td>{{ row.qualified }}</td>
                      <td>{{ row.participation }}</td>
                      <td>{{ row.total }}</td>
                    </tr>
                    <tr class="fw-bold table-light" v-if="markEntryReport.length">
                      <td class="text-end">Total</td>
                      <td>{{ markEntryReportTotals.qualified }}</td>
                      <td>{{ markEntryReportTotals.participation }}</td>
                      <td>{{ markEntryReportTotals.total }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p v-if="markEntryReport.length === 0" class="text-muted text-center py-3">No mark entries found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete confirmation (same as relief: Warning icon, വേണം/വേണ്ട) -->
    <dialog-model
      :message="dialog_message"
      :action_method="dialog_action"
      :action_method_params="dialog_action_params"
      ref="dialog_model"
    ></dialog-model>

    <!-- Success/Error alert (same as relief) -->
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
  </div>
</template>

<script>
import UserService from "../services/user.service";
import $ from "jquery";
import DialogModel from "./layouts/DialogModel.vue";
import AlertModel from "./layouts/AlertModel.vue";

export default {
  name: "QVPKidsList",
  components: {
    DialogModel,
    AlertModel,
  },
  data() {
    return {
      loading: false,
      loading_list: false,
      message: "",
      user_level: "",
      registrants: [],
      pagination: { current_page: 1, total: 0, per_page: 20, from: 1 },

      // Search
      search_query: "",
      search_timeout: null,

      // Filters
      filters: { district: "", zone: "", unit: "", registration_type: "" },
      districtsList: [],
      zonesList: [],
      unitsList: [],

      // Kids registration modal
      showKidsModal: false,
      editingRegistrantId: null,
      loadingKidsRegistration: false,
      kidsForm: {
        name: "",
        age: "",
        gender: "",
        kids_subcategory: "",
        parent_name: "",
        parent_mobile: "",
        country_code: "91",
        district_id: "",
        zone_id: "",
        unit_id: "",
        place: "",
      },
      allDistricts: [],
      zones: [],
      kidsUnits: [],

      // Marks / certificate (single)
      marksForm: {
        registrantId: null,
        mark: null,
        grade: "",
        certificate_url: "",
        loading: false,
      },

      // Final exam mark (single) - State admin only
      finalMarksForm: {
        registrantId: null,
        mark: null,
        rank: null,
        loading: false,
      },

      // Bulk marks / certificates
      bulkMarks: [],
      bulkMarksSaving: false,
      bulkCertificates: [],
      bulkMarksLoading: false,

      // Exam centers (per zone)
      examCenters: [],
      selectedExamCenterId: "",

      // Payment status
      selectedRegistrant: null,
      selectedPaymentStatus: "",
      paymentStatusMessage: "",
      canUpdatePayment: false,

      // Dialog (delete confirmation - same as relief)
      dialog_message: "",
      dialog_action: "",
      dialog_action_params: [],

      // Alert (success/error after action - same as relief)
      alert_type: "",
      alert_message: "",

      // Excel download
      excelDownloading: false,
      pdfDownloading: false,
      finalMarksPdfDownloading: false,

      // Mark Entry Count Report (State/District admins)
      markEntryReport: [],
      markEntryReportLoading: false,
      markEntryReportGroupBy: "",
      markEntryReportTab: "All", // 'All' | 'Junior' | 'Senior'
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    hasActiveFilters() {
      return this.filters.district || this.filters.zone || this.filters.unit || this.filters.registration_type;
    },
    showDistrictFilter() {
      const userLevel = this.user_level ?? parseInt(this.currentUser?.user_level || 0);
      return userLevel === 1 || userLevel === 0;
    },
    showZoneFilter() {
      const userLevel = this.user_level ?? parseInt(this.currentUser?.user_level || 0);
      return userLevel === 1 || userLevel === 0 || userLevel === 2;
    },
    showUnitFilter() {
      const userLevel = this.user_level ?? parseInt(this.currentUser?.user_level || 0);
      return userLevel === 1 || userLevel === 0 || userLevel === 2 || userLevel === 3;
    },
    isAdmin() {
      const userLevel = parseInt(this.currentUser?.user_level || 0);
      return userLevel >= 1 && userLevel <= 4;
    },
    // Bulk Marks button visibility:
    // - Zone view (sub_level === 3): user levels 1–3 (state, district, zone)
    // - Unit view (sub_level === 4): user levels 1–4 (state, district, zone, unit)
    // - Fallback (no sub_level): zone & unit admins (3, 4)
    isMarksAdmin() {
      const userLevel = parseInt(this.currentUser?.user_level || 0);
      const routeLevel = parseInt(this.$route.params.sub_level || 0);

      if (routeLevel === 3) {
        return userLevel >= 1 && userLevel <= 3;
      }

      if (routeLevel === 4) {
        return userLevel >= 1 && userLevel <= 4;
      }

      return userLevel === 3 || userLevel === 4;
    },
    isStateAdmin() {
      const routeLevel = parseInt(this.$route.params.sub_level || 0);
      const userLevel = parseInt(this.currentUser?.user_level || 0);
      if (routeLevel === 1 || routeLevel === 0) return userLevel === 1 || userLevel === 0;
      return false;
    },
    isDistrictAdmin() {
      const routeLevel = parseInt(this.$route.params.sub_level || 0);
      const userLevel = parseInt(this.currentUser?.user_level || 0);
      if (routeLevel === 2) return true;
      return userLevel === 2;
    },
    showMarkEntryReportButton() {
      return this.isStateAdmin || this.isDistrictAdmin || this.isZoneAdmin;
    },
    isZoneAdmin() {
      const routeLevel = parseInt(this.$route.params.sub_level || 0);
      const userLevel = parseInt(this.currentUser?.user_level || 0);
      if (routeLevel === 3) return true;
      return userLevel === 3;
    },
    markEntryReportTotals() {
      const totals = { qualified: 0, participation: 0, total: 0 };
      if (!Array.isArray(this.markEntryReport)) return totals;
      for (const row of this.markEntryReport) {
        totals.qualified += Number(row.qualified || 0);
        totals.participation += Number(row.participation || 0);
        totals.total += Number(row.total || 0);
      }
      return totals;
    },
    isUnitAdmin() {
      const routeLevel = parseInt(this.$route.params.sub_level || 0);
      const userLevel = parseInt(this.currentUser?.user_level || 0);
      if (routeLevel === 4) return true;
      return userLevel === 4;
    },
    shouldShowZoneField() {
      if (this.isDistrictAdmin) return true;
      if (this.isZoneAdmin) return false;
      if (this.isStateAdmin) return !!this.kidsForm.district_id;
      return false;
    },
    shouldShowKidsUnitField() {
      if (this.isUnitAdmin) return false;
      if (this.isZoneAdmin) return true;
      if (this.isDistrictAdmin || this.isStateAdmin) return !!this.kidsForm.zone_id;
      return false;
    },
    pageTitle() {
      const level = parseInt(this.user_level ?? this.$route.params.sub_level);
      let levelText = "";
      if (level === 1 || level === 0) levelText = "സ്റ്റേറ്റ്";
      else if (level === 2) levelText = "ജില്ല";
      else if (level === 3) levelText = "മണ്ഡലം";
      else if (level === 4) levelText = "യൂണിറ്റ്";
      return `${levelText ? levelText + " " : ""}${this.$t("qvp_registrants_list") || "QVP രജിസ്ട്രേഷൻ ലിസ്റ്റ്"}`;
    },
  },
  mounted() {
    if (!this.currentUser) {
      location.replace("/");
      return;
    }
    this.user_level = parseInt(this.$route.params.sub_level);
    this.fetchCanUpdatePayment();
    this.loadFilterData();
    this.getKidsList(1);
    this.loadExamCenters();
    this.$root.updateParent(this.$t("qvp_registrants_list") || "QVP രജിസ്ട്രേഷൻ ലിസ്റ്റ്");
  },
  methods: {
    getCategoryDisplayName(kidsSubcategory) {
      if (!kidsSubcategory) return "";
      const s = String(kidsSubcategory).toLowerCase();
      if (s === "junior") return "കിഡ്‌സ് - ജൂനിയർ";
      if (s === "senior") return "കിഡ്‌സ് - സീനിയർ";
      return kidsSubcategory;
    },
    /** QVP row id, or qhls_reg_no when assigned (same as exports). */
    registrationDisplayNo(registrant) {
      if (!registrant) return "";
      const custom = registrant.qhls_reg_no != null && String(registrant.qhls_reg_no).trim() !== "";
      if (custom) return String(registrant.qhls_reg_no).trim();
      return registrant.id != null && registrant.id !== "" ? String(registrant.id) : "";
    },
    isPublicRegistration(registrant) {
      if (!registrant) return false;
      const rt = String(registrant.registration_type || "").toLowerCase().trim();
      return rt === "public" || rt === "online";
    },
    async fetchCanUpdatePayment() {
      try {
        const response = await UserService.authPostRequest("can-update-qvp-payment", {});
        this.canUpdatePayment = response.data?.data?.can_update === true;
      } catch (e) {
        this.canUpdatePayment = false;
      }
    },
    getKidsList(page = 1) {
      this.loading_list = true;

      const data = {
        category: "kids",
        per_page: 20,
        q: this.search_query || "",
      };

      const user = this.currentUser;
      const userLevel = this.user_level ?? (user?.user_level ?? 0);

      if (userLevel === 2) {
        if (this.$route.params.id) data.district_id = parseInt(this.$route.params.id);
        else if (user?.district_id) data.district_id = parseInt(user.district_id);
      } else if (userLevel === 3) {
        if (this.$route.params.id) data.zone_id = parseInt(this.$route.params.id);
        else if (user?.zone_id) data.zone_id = parseInt(user.zone_id);
      } else if (userLevel === 4) {
        if (this.$route.params.id) data.unit_id = parseInt(this.$route.params.id);
        else if (user?.unit_id) data.unit_id = parseInt(user.unit_id);
      }

      if (this.filters.district) data.district_id = parseInt(this.filters.district);
      if (this.filters.zone) data.zone_id = parseInt(this.filters.zone);
      if (this.filters.unit) {
        data.unit_id = parseInt(this.filters.unit);
        // When only unit is set (e.g. state admin with unit-only filter), send unit's zone_id/district_id so backend returns all kids in that unit
        if ((userLevel === 0 || userLevel === 1) && !data.zone_id && !data.district_id) {
          const selectedUnit = this.unitsList.find(u => u.id == this.filters.unit || u.id === parseInt(this.filters.unit));
          if (selectedUnit) {
            if (selectedUnit.zone_id) data.zone_id = parseInt(selectedUnit.zone_id);
            if (selectedUnit.district_id) data.district_id = parseInt(selectedUnit.district_id);
          }
        }
      }
      if (this.filters.registration_type) data.registration_type = this.filters.registration_type;

      const timestamp = new Date().getTime();
      UserService.authPostRequest(`get-qvp-registrants?page=${page}&_t=${timestamp}`, data).then(
        (response) => {
          if (response.data.status === "success" && response.data.data && response.data.data.list) {
            const paginatedList = response.data.data.list;
            const list = paginatedList.data || [];
            this.registrants = list;
            this.pagination = {
              current_page: paginatedList.current_page || page,
              total: paginatedList.total || 0,
              per_page: paginatedList.per_page || 20,
              from: paginatedList.from || 1,
            };
            this.message = "";
          } else {
            this.registrants = [];
            this.message = response.data.message || "No kids registrations found";
          }
          this.loading_list = false;
        },
        (error) => {
          this.registrants = [];
          this.message = error?.response?.data?.message || error.message || "Error loading kids registrations";
          this.loading_list = false;
        }
      );
    },
    handlePageChange(page) {
      this.pagination.current_page = page;
      this.getKidsList(page);
    },
    handleSearch() {
      if (this.search_timeout) clearTimeout(this.search_timeout);
      this.search_timeout = setTimeout(() => {
        this.pagination.current_page = 1;
        this.getKidsList(1);
      }, 500);
    },
    clearSearch() {
      this.search_query = "";
      this.pagination.current_page = 1;
      this.getKidsList(1);
    },
    applyFilters() {
      this.pagination.current_page = 1;
      this.getKidsList(1);
    },
    clearFilters() {
      this.filters = { district: "", zone: "", unit: "", registration_type: "" };
      this.pagination.current_page = 1;
      this.getKidsList(1);
    },
    showActionModel() {},

    async loadFilterData() {
      const userLevel = this.user_level ?? parseInt(this.currentUser?.user_level || 0);
      try {
        if (userLevel === 1 || userLevel === 0) {
          const resp = await UserService.authPostRequest("get-district-by-id", {});
          this.districtsList = resp.data?.data?.list || [];
        }

        if (userLevel === 2) {
          const districtId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(this.currentUser?.district_id || 0);
          if (districtId) {
            const resp = await UserService.authPostRequest("get-zone-by-id", { district_id: districtId });
            this.zonesList = resp.data?.data?.list || [];
          }
        }

        if (userLevel === 3) {
          const zoneId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(this.currentUser?.zone_id || 0);
          if (zoneId) {
            const resp = await UserService.authPostRequest("get-unit-by-id", { zone_id: zoneId });
            this.unitsList = resp.data?.data?.list || [];
          }
        }
      } catch (e) {
        // ignore
      }
    },
    async onDistrictFilterChange() {
      this.filters.zone = "";
      this.filters.unit = "";
      this.zonesList = [];
      this.unitsList = [];
      if (!this.filters.district) return;
      const resp = await UserService.authPostRequest("get-zone-by-id", { district_id: parseInt(this.filters.district) });
      this.zonesList = resp.data?.data?.list || [];
    },
    async onZoneFilterChange() {
      this.filters.unit = "";
      this.unitsList = [];
      if (!this.filters.zone) return;
      const resp = await UserService.authPostRequest("get-unit-by-id", { zone_id: parseInt(this.filters.zone) });
      this.unitsList = resp.data?.data?.list || [];
      // Reload exam centers when zone changes
      this.loadExamCenters();
    },
    async loadExamCenters() {
      try {
        let zoneId = null;
        const user = this.currentUser;
        const userLevel = this.user_level ?? parseInt(this.currentUser?.user_level || 0);

        if (this.filters.zone) {
          zoneId = parseInt(this.filters.zone);
        } else if (userLevel === 3) {
          zoneId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(user?.zone_id || 0);
        }

        if (!zoneId) {
          this.examCenters = [];
          this.selectedExamCenterId = "";
          return;
        }

        const response = await UserService.authPostRequest("qvp-kids-exam-centers", {
          zone_id: zoneId,
        });
        const list = response?.data?.data?.list || [];
        this.examCenters = list;
        if (this.examCenters.length === 1) {
          this.selectedExamCenterId = this.examCenters[0].id;
        }
      } catch (e) {
        this.examCenters = [];
        this.selectedExamCenterId = "";
      }
    },

    openKidsRegistrationModal() {
      this.editingRegistrantId = null;
      this.showKidsModal = true;
      this.resetKidsForm();
      if (this.isStateAdmin) {
        this.kidsForm.zone_id = "";
        this.kidsForm.district_id = "";
        this.zones = [];
        this.loadAllDistricts();
      } else if (this.isDistrictAdmin) {
        let districtId = null;
        if (this.$route.params.id) districtId = parseInt(this.$route.params.id);
        else if (this.currentUser?.district_id) districtId = parseInt(this.currentUser.district_id);
        if (districtId) {
          this.kidsForm.district_id = districtId;
          this.loadZonesForDistrict(districtId);
        }
      } else if (this.isZoneAdmin) {
        let zoneId = null;
        if (this.$route.params.id) zoneId = parseInt(this.$route.params.id);
        else if (this.currentUser?.zone_id) zoneId = parseInt(this.currentUser.zone_id);
        if (this.currentUser?.district_id) this.kidsForm.district_id = this.currentUser.district_id;
        if (zoneId) {
          this.kidsForm.zone_id = zoneId;
          this.loadKidsUnitsForZone(zoneId);
        }
      } else if (this.isUnitAdmin) {
        const unitId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(this.currentUser?.unit_id || 0);
        if (this.currentUser?.district_id) this.kidsForm.district_id = this.currentUser.district_id;
        if (this.currentUser?.zone_id) this.kidsForm.zone_id = this.currentUser.zone_id;
        if (unitId) this.kidsForm.unit_id = unitId;
      }
      document.body.style.overflow = "hidden";
    },
    closeKidsModal() {
      this.showKidsModal = false;
      this.editingRegistrantId = null;
      document.body.style.overflow = "";
    },
    resetKidsForm() {
      this.kidsForm = {
        name: "",
        age: "",
        gender: "",
        kids_subcategory: "",
        parent_name: "",
        parent_mobile: "",
        country_code: "91",
        district_id: "",
        zone_id: "",
        unit_id: "",
        place: "",
      };
      this.zones = [];
      this.kidsUnits = [];
    },
    parseParentFromComments(comments) {
      if (!comments || typeof comments !== "string") return { parent_name: "", parent_mobile: "" };
      let parent_name = "";
      let parent_mobile = "";
      const parentMatch = comments.match(/Parent:\s*([^,]+)/);
      if (parentMatch) parent_name = parentMatch[1].trim();
      const mobileMatch = comments.match(/Parent Mobile:\s*([^,]+)/);
      if (mobileMatch) parent_mobile = mobileMatch[1].trim();
      return { parent_name, parent_mobile };
    },
    async openEditKidsModal(registrant) {
      this.editingRegistrantId = registrant.id;
      const { parent_name, parent_mobile } = this.parseParentFromComments(registrant.comments);
      let gender = (registrant.gender || "").toString();
      if (gender === "F" || gender.toUpperCase() === "G") gender = "Girl";
      else if (gender === "M" || gender.toUpperCase() === "B") gender = "Boy";
      let sub = (registrant.kids_subcategory || "").toString().toLowerCase();
      if (sub !== "junior" && sub !== "senior") sub = "";
      this.kidsForm = {
        name: registrant.name || "",
        age: registrant.age != null ? String(registrant.age) : "",
        gender: gender || "",
        kids_subcategory: sub,
        parent_name: parent_name || "",
        parent_mobile: parent_mobile || registrant.mobile || "",
        country_code: registrant.country_code || "91",
        district_id: registrant.district_id != null ? registrant.district_id : "",
        zone_id: registrant.zone_id != null ? registrant.zone_id : "",
        unit_id: registrant.unit_id != null ? registrant.unit_id : "",
        place: registrant.place || "",
      };
      if (this.isStateAdmin) {
        await this.loadAllDistricts();
        if (this.kidsForm.district_id) await this.loadZonesForDistrict(parseInt(this.kidsForm.district_id));
        if (this.kidsForm.zone_id) await this.loadKidsUnitsForZone(parseInt(this.kidsForm.zone_id));
      } else if (this.isDistrictAdmin) {
        const districtId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(this.currentUser?.district_id || 0);
        if (districtId) await this.loadZonesForDistrict(districtId);
        if (this.kidsForm.zone_id) await this.loadKidsUnitsForZone(parseInt(this.kidsForm.zone_id));
      } else if (this.isZoneAdmin) {
        const zoneId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(this.currentUser?.zone_id || 0);
        if (zoneId) await this.loadKidsUnitsForZone(zoneId);
      }
      this.showKidsModal = true;
      document.body.style.overflow = "hidden";
    },
    confirmDeleteRegistrant(registrant) {
      this.dialog_message = this.$t("confirm_delete_registrant") || "ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?";
      this.dialog_action_params = [registrant];
      this.dialog_action = "doDeleteRegistrant";
      this.$refs.dialog_model.openModel();
    },
    async doDeleteRegistrant(params) {
      if (!params || !params[0]) return;
      const registrant = params[0];
      await this.deleteRegistrant(registrant.id);
    },
    async deleteRegistrant(id) {
      this.loading_list = true;
      try {
        const response = await UserService.authPostRequest("delete-qhls", { id });
        if (response.data.status === "success") {
          this.alert_type = "Success";
          this.alert_message = response.data.message || (this.$t("deleted_successfully") || "Deleted successfully");
          this.$refs.alert_model.openModel();
          this.getKidsList(this.pagination.current_page);
        } else if (response.data.status === "warning") {
          this.alert_type = "Warning";
          this.alert_message = response.data.message || (this.$t("delete_failed") || "Delete failed");
          this.$refs.alert_model.openModel();
        } else {
          this.alert_type = "Error";
          this.alert_message = response.data.message || (this.$t("delete_failed") || "Delete failed");
          this.$refs.alert_model.openModel();
        }
      } catch (error) {
        this.alert_type = "Error";
        this.alert_message = error.response?.data?.message || (this.$t("delete_failed") || "Delete failed");
        this.$refs.alert_model.openModel();
      } finally {
        this.loading_list = false;
      }
    },
    handleKidsAgeChange() {
      if (!this.kidsForm.age) return;
      const age = parseInt(this.kidsForm.age);
      const currentYear = new Date().getFullYear();
      const birthYear = currentYear - age;
      if (birthYear > 2017) this.kidsForm.kids_subcategory = "junior";
      else if (birthYear >= 2014 && birthYear <= 2017) this.kidsForm.kids_subcategory = "senior";
      else this.kidsForm.kids_subcategory = "";
    },
    async loadAllDistricts() {
      const response = await UserService.authPostRequest("get-district-by-id", {});
      this.allDistricts = response.data?.data?.list || [];
    },
    async loadZonesForDistrict(districtId) {
      const response = await UserService.authPostRequest("get-zone-by-id", { district_id: districtId });
      this.zones = response.data?.data?.list || [];
    },
    async handleDistrictChange() {
      const did = this.kidsForm.district_id;
      this.kidsForm.zone_id = "";
      this.kidsForm.unit_id = "";
      this.kidsUnits = [];
      if (!did) return;
      await this.loadZonesForDistrict(parseInt(did));
    },
    async handleZoneChange() {
      const zid = this.kidsForm.zone_id;
      this.kidsForm.unit_id = "";
      this.kidsUnits = [];
      if (!zid) return;
      await this.loadKidsUnitsForZone(parseInt(zid));
    },
    async loadKidsUnitsForZone(zoneId) {
      const response = await UserService.authPostRequest("get-unit-by-id", { zone_id: zoneId });
      this.kidsUnits = response.data?.data?.list || [];
    },
    async openMarkEntryCountReport() {
      this.markEntryReportTab = "All";
      this.markEntryReport = [];
      this.markEntryReportGroupBy = "";
      $("#markEntryReportModal").modal("show");
      await this.fetchMarkEntryReport();
    },
    async setMarkEntryReportTab(tab) {
      if (this.markEntryReportTab === tab) return;
      this.markEntryReportTab = tab;
      await this.fetchMarkEntryReport();
    },
      async fetchMarkEntryReport() {
        this.markEntryReportLoading = true;
        const routeLevel = parseInt(this.$route.params.sub_level ?? this.user_level ?? 0);
        const payload = {};
        if (routeLevel === 2 && this.$route.params.id) {
          // District context: zone-wise within this district
          payload.district_id = parseInt(this.$route.params.id);
          payload.group_by = "zone";
        } else if (routeLevel === 3 && this.$route.params.id) {
          // Zone context (state or zone admin): unit-wise within this zone
          payload.zone_id = parseInt(this.$route.params.id);
          payload.group_by = "unit";
        }
      if (this.markEntryReportTab !== "All") {
        payload.kids_subcategory = this.markEntryReportTab;
      }
      try {
        const response = await UserService.authPostRequest("qvp-kids-mark-entry-count-report", payload);
        if (response.data?.status === "success" && response.data?.data) {
          this.markEntryReport = response.data.data.report || [];
          this.markEntryReportGroupBy = response.data.data.group_by || "";
        } else {
          this.showAlert(response.data?.message || "Failed to load report", "error");
        }
      } catch (err) {
        this.showAlert(err.response?.data?.message || err.message || "Failed to load report", "error");
      } finally {
        this.markEntryReportLoading = false;
      }
    },
    closeMarkEntryReportModal() {
      $("#markEntryReportModal").modal("hide");
    },
      async downloadQualifiedKidsPdf() {
        this.pdfDownloading = true;
        try {
        const routeLevel = parseInt(this.$route.params.sub_level ?? this.user_level ?? 0);
        const data = {};

        // For district admin (zone-wise view), send district_id so backend scopes correctly
        if (routeLevel === 2 && this.$route.params.id) {
          data.district_id = parseInt(this.$route.params.id);
        } else if (routeLevel === 3 && this.$route.params.id) {
          // For zone context, restrict qualified list to this zone
          data.zone_id = parseInt(this.$route.params.id);
        }

          // Respect current Junior/Senior tab filter
          if (this.markEntryReportTab === "Junior" || this.markEntryReportTab === "Senior") {
            data.kids_subcategory = this.markEntryReportTab.toLowerCase();
          }

          const response = await UserService.authPostRequest("qvp-kids-qualified-pdf-link", data);
          const link = response?.data?.data?.link;
          if (response.data.status === "success" && link) {
            // Match Mark List PDF behavior: open in same tab
            window.location.href = link;
          } else {
            this.showAlert(response.data?.message || "Failed to open qualified list PDF", "error");
          }
        } catch (err) {
          const msg = err?.response?.data?.message || err?.message || "Failed to open qualified list PDF";
          this.showAlert(msg, "error");
        } finally {
          this.pdfDownloading = false;
        }
      },
      async downloadQualifiedKidsHallTicketPdf() {
        this.pdfDownloading = true;
        try {
          const routeLevel = parseInt(this.$route.params.sub_level ?? this.user_level ?? 0);
          const data = {};

          if (routeLevel === 2 && this.$route.params.id) {
            data.district_id = parseInt(this.$route.params.id);
          } else if (routeLevel === 3 && this.$route.params.id) {
            data.zone_id = parseInt(this.$route.params.id);
          }

          if (this.markEntryReportTab === "Junior" || this.markEntryReportTab === "Senior") {
            data.kids_subcategory = this.markEntryReportTab.toLowerCase();
          }

          const response = await UserService.authPostRequest("qvp-kids-hall-ticket-pdf-link", data);
          const link = response?.data?.data?.link;
          if (response.data.status === "success" && link) {
            window.location.href = link;
          } else {
            this.showAlert(response.data?.message || "Failed to open hall ticket PDF", "error");
          }
        } catch (err) {
          const msg = err?.response?.data?.message || err?.message || "Failed to open hall ticket PDF";
          this.showAlert(msg, "error");
        } finally {
          this.pdfDownloading = false;
        }
      },
    // Single kid marks modal
    openMarksModal(registrant) {
      this.marksForm.registrantId = registrant.id;
      this.marksForm.mark = registrant.qvp_exam_mark != null ? registrant.qvp_exam_mark : null;
      this.marksForm.grade = registrant.qvp_exam_grade || "";
      this.marksForm.certificate_url = "";
      this.marksForm.loading = false;
      $("#kidsMarkModal").modal("show");
    },
    closeMarksModal() {
      $("#kidsMarkModal").modal("hide");
      this.marksForm.registrantId = null;
      this.marksForm.mark = null;
      this.marksForm.grade = "";
      this.marksForm.certificate_url = "";
      this.marksForm.loading = false;
    },
    async saveKidsMark() {
      if (!this.marksForm.registrantId) {
        this.showAlert("No registrant selected.", "error");
        return;
      }
      if (this.marksForm.mark === null || this.marksForm.mark === "") {
        this.showAlert("Please enter mark.", "error");
        return;
      }
      const mark = parseInt(this.marksForm.mark, 10);
      if (isNaN(mark) || mark < 0 || mark > 100) {
        this.showAlert("Mark must be between 0 and 100.", "error");
        return;
      }
      this.marksForm.loading = true;
      try {
        const data = { id: this.marksForm.registrantId, mark };
        const response = await UserService.authPostRequest("save-qvp-kids-mark", data);
        if (response.data.status === "success") {
          const resp = response.data.data || {};
          this.marksForm.grade = resp.grade || "";
          this.marksForm.certificate_url = resp.certificate_url || "";
          this.showAlert(response.data.message || "Mark saved successfully.", "success");
          this.getKidsList(this.pagination.current_page);
        } else {
          this.showAlert(response.data.message || "Failed to save mark.", "error");
        }
      } catch (error) {
        const msg = error.response?.data?.message || "Failed to save mark. Please try again.";
        this.showAlert(msg, "error");
      } finally {
        this.marksForm.loading = false;
      }
    },

    // Kids final exam mark modal
    openFinalMarksModal(registrant) {
      this.finalMarksForm.registrantId = registrant.id;
      this.finalMarksForm.mark = registrant.qvp_final_exam_mark != null ? registrant.qvp_final_exam_mark : null;
      this.finalMarksForm.rank = registrant.qvp_final_exam_rank != null ? registrant.qvp_final_exam_rank : null;
      this.finalMarksForm.loading = false;
      $("#kidsFinalMarkModal").modal("show");
    },
    closeFinalMarksModal() {
      $("#kidsFinalMarkModal").modal("hide");
      this.finalMarksForm.registrantId = null;
      this.finalMarksForm.mark = null;
      this.finalMarksForm.rank = null;
      this.finalMarksForm.loading = false;
    },
    async saveKidsFinalMark() {
      if (!this.finalMarksForm.registrantId) {
        this.showAlert("No registrant selected.", "error");
        return;
      }
      if (this.finalMarksForm.mark === null || this.finalMarksForm.mark === "") {
        this.showAlert("Please enter final exam mark.", "error");
        return;
      }
      const mark = parseInt(this.finalMarksForm.mark, 10);
      if (isNaN(mark) || mark < 0 || mark > 100) {
        this.showAlert("Final mark must be between 0 and 100.", "error");
        return;
      }
      if (this.finalMarksForm.rank === null || this.finalMarksForm.rank === "") {
        this.showAlert("Please enter rank.", "error");
        return;
      }
      const rank = parseInt(this.finalMarksForm.rank, 10);
      if (isNaN(rank) || rank < 1) {
        this.showAlert("Rank must be a positive number.", "error");
        return;
      }
      this.finalMarksForm.loading = true;
      try {
        const response = await UserService.authPostRequest("save-qvp-kids-final-mark", {
          id: this.finalMarksForm.registrantId,
          mark,
          rank,
        });
        if (response.data.status === "success") {
          this.showAlert(response.data.message || "Final mark saved successfully.", "success");
          this.getKidsList(this.pagination.current_page);
          this.closeFinalMarksModal();
        } else {
          this.showAlert(response.data.message || "Failed to save final mark.", "error");
        }
      } catch (error) {
        const msg = error.response?.data?.message || "Failed to save final mark. Please try again.";
        this.showAlert(msg, "error");
      } finally {
        this.finalMarksForm.loading = false;
      }
    },
    // Bulk marks modal helpers
    async openBulkMarksModal() {
      this.bulkMarks = [];
      this.bulkCertificates = [];
      this.bulkMarksSaving = false;
      this.bulkMarksLoading = true;
      $("#bulkKidsMarksModal").modal("show");

      try {
        // Build same filter payload as getKidsList, but fetch all (large per_page)
        const data = {
          category: "kids",
          per_page: 1000,
          q: this.search_query || "",
        };

        const user = this.currentUser;
        const userLevel = this.user_level ?? (user?.user_level ?? 0);

        if (userLevel === 2) {
          if (this.$route.params.id) data.district_id = parseInt(this.$route.params.id);
          else if (user?.district_id) data.district_id = parseInt(user.district_id);
        } else if (userLevel === 3) {
          if (this.$route.params.id) data.zone_id = parseInt(this.$route.params.id);
          else if (user?.zone_id) data.zone_id = parseInt(user.zone_id);
        } else if (userLevel === 4) {
          if (this.$route.params.id) data.unit_id = parseInt(this.$route.params.id);
          else if (user?.unit_id) data.unit_id = parseInt(user.unit_id);
        }

        if (this.filters.district) data.district_id = parseInt(this.filters.district);
        if (this.filters.zone) data.zone_id = parseInt(this.filters.zone);
        if (this.filters.unit) {
          data.unit_id = parseInt(this.filters.unit);
          if ((userLevel === 0 || userLevel === 1) && !data.zone_id && !data.district_id) {
            const selectedUnit = this.unitsList.find(
              (u) => u.id == this.filters.unit || u.id === parseInt(this.filters.unit)
            );
            if (selectedUnit) {
              if (selectedUnit.zone_id) data.zone_id = parseInt(selectedUnit.zone_id);
              if (selectedUnit.district_id) data.district_id = parseInt(selectedUnit.district_id);
            }
          }
        }
        if (this.filters.registration_type) data.registration_type = this.filters.registration_type;

        const timestamp = new Date().getTime();
        const response = await UserService.authPostRequest(
          `get-qvp-registrants?page=1&_t=${timestamp}`,
          data
        );

        const paginatedList = response?.data?.data?.list;
        const allKids = paginatedList?.data || [];

        this.bulkMarks = allKids.map((r) => ({
          id: r.id,
          name: r.name || "",
          place: r.place || "",
          mark: r.qvp_exam_mark != null ? r.qvp_exam_mark : null,
          grade: r.qvp_exam_grade || this.computeGradeForMark(r.qvp_exam_mark),
          certificate_url: "",
          error: "",
        }));
      } catch (e) {
        this.bulkMarks = [];
        this.showAlert("Failed to load kids list for marks.", "error");
      } finally {
        this.bulkMarksLoading = false;
      }
    },
    closeBulkMarksModal() {
      $("#bulkKidsMarksModal").modal("hide");
      this.bulkMarks = [];
      this.bulkCertificates = [];
      this.bulkMarksSaving = false;
    },
    computeGradeForMark(mark) {
      const m = parseInt(mark, 10);
      if (isNaN(m)) return "";
      if (m >= 40) return "Distinction";
      if (m >= 31 && m <= 39) return "First Class";
      if (m >= 21 && m <= 30) return "Second Class";
      if (m >= 1 && m <= 20) return "Participation";
      return "";
    },
    async saveBulkMarks() {
      // Clear previous per-entry errors
      this.bulkMarks.forEach((e) => {
        if (e) e.error = "";
      });

      const entries = this.bulkMarks.filter((e) => e.mark !== null && e.mark !== "");
      if (!entries.length) {
        this.showAlert("Please enter at least one mark before saving.", "error");
        return;
      }

      this.bulkMarksSaving = true;
      this.bulkCertificates = [];

      const failedEntries = [];
      let tooManyAttemptsError = null;

      try {
        for (const entry of entries) {
          const mark = parseInt(entry.mark, 10);
          if (isNaN(mark) || mark < 0 || mark > 100) {
            const message = "Invalid mark (must be 0–100).";
            entry.error = message;
            failedEntries.push({ name: entry.name, message });
            continue;
          }

          try {
            const response = await UserService.authPostRequest("save-qvp-kids-mark", {
              id: entry.id,
              mark,
            });

            if (response.data.status === "success") {
              const resp = response.data.data || {};
              entry.grade = resp.grade || this.computeGradeForMark(mark);
              entry.certificate_url = resp.certificate_url || "";
              if (entry.certificate_url) {
                this.bulkCertificates.push({
                  id: entry.id,
                  certificate_url: entry.certificate_url,
                });
              }
            } else {
              const message = response.data.message || "Failed to save mark.";
              entry.error = message;
              failedEntries.push({ name: entry.name, message });
              if (/Too Many Attempts/i.test(message)) {
                tooManyAttemptsError = message;
                break;
              }
            }
          } catch (e) {
            const message = e?.response?.data?.message || e.message || "Failed to save mark.";
            entry.error = message;
            failedEntries.push({ name: entry.name, message });

            if (e?.response?.status === 429 || /Too Many Attempts/i.test(message)) {
              tooManyAttemptsError = message;
              break;
            }
          }
        }

        if (tooManyAttemptsError) {
          this.showAlert(
            tooManyAttemptsError || "Too many attempts while saving marks. Please wait a minute and try again in smaller batches.",
            "error"
          );
        } else if (failedEntries.length) {
          const successCount = entries.length - failedEntries.length;
          const failedNames = failedEntries
            .map((f) => f.name)
            .filter(Boolean)
            .slice(0, 5)
            .join(", ");
          let msg = `Marks saved for ${successCount} kid(s). Failed for ${failedEntries.length} kid(s).`;
          if (failedNames) {
            msg += ` Examples: ${failedNames}${failedEntries.length > 5 ? " +" + (failedEntries.length - 5) + " more" : ""}.`;
          }
          this.showAlert(msg, "error");
        } else {
          this.showAlert("Marks saved successfully.", "success");
        }

        this.getKidsList(this.pagination.current_page);
      } finally {
        this.bulkMarksSaving = false;
      }
    },
    downloadBulkCertificates() {
      if (!this.bulkCertificates.length) return;

      const ids = this.bulkCertificates.map((c) => c.id);
      const firstUrl = this.bulkCertificates[0].certificate_url;

      let baseUrl = window.location.origin;
      try {
        if (firstUrl) {
          const u = new URL(firstUrl);
          baseUrl = u.origin;
        }
      } catch (e) {
        // fall back to window.location.origin
      }

      const bulkUrl = `${baseUrl}/print-qvp-kids-certificates-bulk?ids=${ids.join(",")}`;
      window.open(bulkUrl, "_blank");
    },
async submitKidsRegistration() {
      if (!this.kidsForm.name || !this.kidsForm.age || !this.kidsForm.gender || !this.kidsForm.parent_name || !this.kidsForm.parent_mobile) {
        this.showAlert("ദയവായി എല്ലാ നിർബന്ധമായ ഫീൽഡുകളും പൂരിപ്പിക്കുക", "error");
        return;
      }
      if (!this.editingRegistrantId) {
        if (this.isStateAdmin && !this.kidsForm.district_id) {
          this.showAlert("ദയവായി ജില്ല തിരഞ്ഞെടുക്കുക", "error");
          return;
        }
        if (this.isZoneAdmin) {
          if (!this.kidsForm.unit_id) {
            this.showAlert("ദയവായി Unit തിരഞ്ഞെടുക്കുക", "error");
            return;
          }
          if (!this.kidsForm.place) {
            this.showAlert("ദയവായി സ്ഥലം നൽകുക", "error");
            return;
          }
        }
        if (!this.isZoneAdmin && !this.kidsForm.zone_id) {
          this.showAlert("ദയവായി Area തിരഞ്ഞെടുക്കുക", "error");
          return;
        }
        if (!this.isZoneAdmin && !this.isUnitAdmin && !this.kidsForm.unit_id) {
          this.showAlert("ദയവായി Unit തിരഞ്ഞെടുക്കുക", "error");
          return;
        }
      }

      this.loadingKidsRegistration = true;
      try {
        if (this.editingRegistrantId) {
          const updateData = {
            id: this.editingRegistrantId,
            name: this.kidsForm.name,
            age: this.kidsForm.age,
            gender: this.kidsForm.gender,
            kids_subcategory: this.kidsForm.kids_subcategory || null,
            parent_name: this.kidsForm.parent_name,
            parent_mobile: this.kidsForm.parent_mobile,
            country_code: this.kidsForm.country_code || "91",
            district_id: this.kidsForm.district_id || null,
            zone_id: this.kidsForm.zone_id || null,
            unit_id: this.kidsForm.unit_id || null,
            place: this.kidsForm.place || null,
          };
          const response = await UserService.authPostRequest("update-qvp-registrant", updateData);
          if (response.data.status === "success") {
            this.showAlert(this.$t("updated_successfully") || "Updated successfully!", "success");
            this.closeKidsModal();
            this.getKidsList(this.pagination.current_page);
          } else {
            this.showAlert(response.data.message || "Update failed", "error");
          }
          return;
        }

        let finalDistrictId = null;
        let finalZoneId = null;
        let finalUnitId = null;

        if (this.isStateAdmin) {
          finalDistrictId = this.kidsForm.district_id;
          finalZoneId = this.kidsForm.zone_id;
          finalUnitId = this.kidsForm.unit_id;
        } else if (this.isDistrictAdmin) {
          finalDistrictId = this.$route.params.id ? parseInt(this.$route.params.id) : (this.currentUser?.district_id || this.kidsForm.district_id);
          finalZoneId = this.kidsForm.zone_id;
          finalUnitId = this.kidsForm.unit_id;
        } else if (this.isZoneAdmin) {
          finalDistrictId = this.currentUser?.district_id;
          finalZoneId = this.currentUser?.zone_id;
          finalUnitId = this.kidsForm.unit_id;
        } else if (this.isUnitAdmin) {
          finalDistrictId = this.currentUser?.district_id;
          finalZoneId = this.currentUser?.zone_id;
          finalUnitId = this.$route.params.id ? parseInt(this.$route.params.id) : this.currentUser?.unit_id;
        }

        const parentMobile = this.kidsForm.parent_mobile;
        const registrationData = {
          form_name: "QVP_REGISTRATION",
          new_reg: true,
          registration_source: "admin",
          new: {
            name: this.kidsForm.name,
            age: this.kidsForm.age,
            gender: this.kidsForm.gender,
            category: "kids",
            kids_subcategory: this.kidsForm.kids_subcategory,
            parent_name: this.kidsForm.parent_name,
            parent_mobile: this.kidsForm.parent_mobile,
            mobile: parentMobile,
            code: "91",
            district_id: finalDistrictId,
            zone_id: finalZoneId,
            unit_id: finalUnitId,
            place: this.isZoneAdmin ? this.kidsForm.place : null,
            registration_type: "member",
          },
        };

        const response = await UserService.authPostRequest("auto-form-submit", registrationData);
        if (response.data.status === "success") {
          this.showAlert("കുട്ടി വിജയകരമായി രജിസ്റ്റർ ചെയ്തു!", "success");
          this.closeKidsModal();
          setTimeout(() => this.getKidsList(1), 800);
        } else {
          this.showAlert(response.data.message || "രജിസ്ട്രേഷൻ പരാജയപ്പെട്ടു", "error");
        }
      } catch (error) {
        const msg = error.response?.data?.message || "രജിസ്ട്രേഷൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.";
        this.showAlert(msg, "error");
      } finally {
        this.loadingKidsRegistration = false;
      }
    },

    openPaymentStatusModal(registrant) {
      this.selectedRegistrant = registrant;
      const status = registrant.payment_status || "";
      this.selectedPaymentStatus = status === "Pending" ? "Pending" : status === "Paid" ? "Paid" : "";
      this.paymentStatusMessage = "";
      $("#paymentStatusModel").modal("show");
    },
    closePaymentStatusModal() {
      $("#paymentStatusModel").modal("hide");
      this.selectedRegistrant = null;
      this.selectedPaymentStatus = "";
      this.paymentStatusMessage = "";
    },
    async savePaymentStatus() {
      if (!this.selectedRegistrant || !this.selectedRegistrant.id) {
        this.paymentStatusMessage = "Invalid registrant data";
        return;
      }
      if (!this.selectedPaymentStatus) {
        this.paymentStatusMessage = "Please select a payment status";
        return;
      }
      this.loading = true;
      try {
        const backendStatus = this.selectedPaymentStatus === "Pending" ? "Pending" : this.selectedPaymentStatus;
        const data = { id: this.selectedRegistrant.id, payment_status: backendStatus, category: "kids" };
        const response = await UserService.authPostRequest("update-qvp-payment-status", data);
        if (response.data.status === "success") {
          this.getKidsList(this.pagination.current_page);
          this.closePaymentStatusModal();
          this.showAlert(response.data.message || "Payment status updated successfully", "success");
        } else {
          this.paymentStatusMessage = response.data.message || "Failed to update payment status";
        }
      } catch (error) {
        this.paymentStatusMessage = error.response?.data?.message || "Failed to update payment status. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    showAlert(message, type) {
      this.alert_type = type === "error" ? "Error" : "Success";
      this.alert_message = message;
      this.$refs.alert_model.openModel();
    },

    async downloadExcel() {
      this.excelDownloading = true;
      try {
        const data = { category: "kids" };
        const user = this.currentUser;
        const userLevel = this.user_level ?? (user?.user_level ?? 0);

        if (userLevel === 2) {
          const districtId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(user?.district_id || 0);
          if (districtId) data.district_id = districtId;
        } else if (userLevel === 3) {
          const zoneId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(user?.zone_id || 0);
          if (zoneId) data.zone_id = zoneId;
        } else if (userLevel === 4) {
          const unitId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(user?.unit_id || 0);
          if (unitId) data.unit_id = unitId;
        }

        if (this.filters.district) data.district_id = parseInt(this.filters.district);
        if (this.filters.zone) data.zone_id = parseInt(this.filters.zone);
        if (this.filters.unit) data.unit_id = parseInt(this.filters.unit);
        if (this.filters.registration_type) data.registration_type = this.filters.registration_type;

        const response = await UserService.authPostRequest("export-qvp-kids-excel", data, { responseType: "blob" });
        const blob = response.data;
        const contentType = (response.headers && response.headers["content-type"]) || "";
        if (contentType.indexOf("application/json") !== -1) {
          const text = await new Promise((res) => {
            const r = new FileReader();
            r.onload = () => res(r.result);
            r.readAsText(blob);
          });
          const json = JSON.parse(text);
          this.showAlert(json.message || "Download failed", "error");
          return;
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "qvp-kids-list-" + new Date().toISOString().slice(0, 10) + ".xlsx";
        a.click();
        URL.revokeObjectURL(url);
      } catch (err) {
        const msg = (err.response && err.response.data && err.response.data.message) || err.message || "Failed to download Excel";
        this.showAlert(msg, "error");
      } finally {
        this.excelDownloading = false;
      }
    },
    async downloadFinalMarksPdf() {
      this.finalMarksPdfDownloading = true;
      try {
        const data = { category: "kids" };
        const user = this.currentUser;
        const userLevel = this.user_level ?? (user?.user_level ?? 0);

        if (userLevel === 2) {
          const districtId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(user?.district_id || 0);
          if (districtId) data.district_id = districtId;
        } else if (userLevel === 3) {
          const zoneId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(user?.zone_id || 0);
          if (zoneId) data.zone_id = zoneId;
        } else if (userLevel === 4) {
          const unitId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(user?.unit_id || 0);
          if (unitId) data.unit_id = unitId;
        }

        if (this.filters.district) data.district_id = parseInt(this.filters.district);
        if (this.filters.zone) data.zone_id = parseInt(this.filters.zone);
        if (this.filters.unit) data.unit_id = parseInt(this.filters.unit);

        const response = await UserService.authPostRequest("qvp-final-marks-pdf-link", data);
        const link = response?.data?.data?.link;
        if (response.data.status === "success" && link) {
          window.location.href = link;
        } else {
          this.showAlert(response.data?.message || "Failed to open final marks PDF", "error");
        }
      } catch (err) {
        const msg = err?.response?.data?.message || err?.message || "Failed to open final marks PDF";
        this.showAlert(msg, "error");
      } finally {
        this.finalMarksPdfDownloading = false;
      }
    },
    async downloadExamCenterPdf(kidsSubcategory) {
      this.pdfDownloading = true;
      try {
        const data = {};
        const user = this.currentUser;
        const userLevel = this.user_level ?? (user?.user_level ?? 0);

        if (userLevel === 2) {
          const districtId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(user?.district_id || 0);
          if (districtId) data.district_id = districtId;
        } else if (userLevel === 3) {
          const zoneId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(user?.zone_id || 0);
          if (zoneId) data.zone_id = zoneId;
        } else if (userLevel === 4) {
          const unitId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(user?.unit_id || 0);
          if (unitId) data.unit_id = unitId;
        }

        if (this.filters.district) data.district_id = parseInt(this.filters.district);
        if (this.filters.zone) data.zone_id = parseInt(this.filters.zone);
        if (this.filters.unit) data.unit_id = parseInt(this.filters.unit);
        if (this.filters.registration_type) data.registration_type = this.filters.registration_type;

        if (kidsSubcategory) {
          data.kids_subcategory = kidsSubcategory;
        }

        const response = await UserService.authPostRequest("qvp-kids-exam-center-pdf-link", data);
        const link = response?.data?.data?.link;
        if (response.data.status === "success" && link) {
          // Navigate current window; spinner covers only API call time
          window.location.href = link;
        }
      } catch (err) {
        const msg = err?.response?.data?.message || err?.message || "Failed to open PDF";
        this.showAlert(msg, "error");
      } finally {
        this.pdfDownloading = false;
      }
    },

    openExamCenterModal() {
      this.examCenterMessage = "";
      $("#examCenterModal").modal("show");
    },
    closeExamCenterModal() {
      $("#examCenterModal").modal("hide");
      this.examCenterMessage = "";
    },
    async handleExamCenterPdfDownload() {
      if (!this.selectedExamCenterId) {
        this.examCenterMessage = "Please select an exam center";
        return;
      }
      this.examCenterMessage = "";
      await this.downloadExamCenterPdf();
    },
  },
};
</script>

<style scoped>
.qvp-kids-list-page .error-feedback {
  color: red;
}

.section-heading-add-kids {
  padding-left: 24px;
  padding-right: 24px;
}

.add-kids-btn-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  gap: 8px;
  flex-wrap: wrap;
}

.add-kids-btn-wrap .btn {
  flex: 1 1 calc(50% - 4px);
  min-width: 0;
  white-space: nowrap;
}

.list-item-container {
  position: relative;
  background-color: #ffffff !important;
  border-radius: 8px;
  margin-bottom: 4px;
  transition: background-color 0.2s ease;
  min-height: 60px;
}

.list-item-container.public-registrant {
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%) !important;
  border-left: 4px solid #2196f3;
}

.list-item-container.public-registrant:hover {
  background: linear-gradient(135deg, #bbdefb 0%, #e1bee7 100%) !important;
}

.item-content {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  min-height: 60px;
  padding: 8px 0;
}

.card-button.dropdown {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.search-section {
  padding: 4px 16px 8px 16px;
}

.search-box .input-wrapper {
  position: relative;
}

.search-input {
  padding-left: 36px;
  padding-right: 36px;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
}

.grade-badge {
  min-width: 88px;
  text-align: center;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.grade-badge-distinction {
  background: #c53030;
  color: #ffffff;
}

.grade-badge-first {
  background: #d69e2e;
  color: #ffffff;
}

.grade-badge-second {
  background: #2b6cb0;
  color: #ffffff;
  line-height: 1.1;
}

.grade-badge-participation {
  background: #4a5568;
  color: #ffffff;
}

.exam-center-select {
  width: 100%;
  margin-top: 8px;
}

.exam-center-select .input-wrapper {
  width: 100%;
}

.exam-center-dropdown {
  width: 100%;
  border-radius: 10px;
}

.clear-search-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  color: #6b7280;
}

.final-mark-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 600;
  background: rgba(34, 197, 94, 0.12); /* green-500 @ 12% */
  color: #166534; /* green-800 */
}

/* Kids Registration Modal */
.kids-registration-modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0);
  transition: background-color 0.3s ease;
}

.kids-registration-modal.modal-open {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content-bottom {
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 12px 14px;
}

.modal-header-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 10px;
}

.modal-title-bottom {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
}

.close-btn {
  background: none;
  border: none;
  padding: 4px;
}

/* Mark Entry Count Report: centered modal with smooth animation (no bottom popup) */
.report-modal-centered .modal-dialog {
  margin: 1rem auto;
  max-width: calc(100% - 2rem);
  transition: transform 0.2s ease-out;
  transform: scale(0.92);
}
.report-modal-centered.show .modal-dialog {
  transform: scale(1);
}
.report-modal-centered .modal-content {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  border: none;
}
.report-modal-centered .modal-body {
  max-height: min(85vh, 560px);
  min-height: 280px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Compact All / Junior / Senior tabs — mobile friendly */
.report-modal-tabs {
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #dee2e6;
  min-height: 0;
}
.report-modal-tabs .nav-item {
  flex: 1;
}
.report-modal-tabs .nav-link {
  padding: 0.35rem 0.5rem;
  font-size: 0.8125rem;
  text-align: center;
  border: none;
  border-radius: 6px;
  margin-bottom: -1px;
  color: #1a418c;
  background: transparent;
}
.report-modal-tabs .nav-link:hover {
  background: rgba(26, 65, 140, 0.08);
}
.report-modal-tabs .nav-link.active {
  font-weight: 600;
  color: #1a418c;
  background: rgba(26, 65, 140, 0.12);
  border-bottom-color: transparent;
}
</style>